import React from "react";
import { Stack } from "../../../Stacks/Stack/Stack";
import { Text, TextProps } from "../../../Text/Text";
import { TruncatedText, TruncatedTextProps } from "../../../TruncatedText/TruncatedText";
import { OperationalContent, OperationalContentProps } from "../shared/OperationalContent";
import { ListItemColumnProps } from "../shared/props";

interface BaseTextColumnProps extends ListItemColumnProps {
    /**
     * Array of Text props to create text elements.
     */
    readonly textElements: readonly TextProps[];

    /**
     * Configuration to render ellipsis for long text
     */
    readonly truncatedTextProps?: Pick<TruncatedTextProps, "lines" | "stopPropagation">;
}

export type TextColumnProps = BaseTextColumnProps & OperationalContentProps;

export const TextColumn: React.FC<TextColumnProps> = ({
    textElements = [],
    disabled = false,
    indentPadding = "0px",
    operationalData,
    truncatedTextProps
}) => {
    return (
        <Stack horizontalAlign="start" padding={indentPadding !== "0px" ? `0px 0px 0px ${indentPadding} ` : undefined}>
            <OperationalContent
                operationalData={operationalData}
            >
                {textElements.map((element, index) =>
                    truncatedTextProps ? (
                        <TruncatedText
                            lines={truncatedTextProps.lines}
                            stopPropagation={false}
                            {...element}
                            disabled={disabled}
                            key={index}
                        />
                    ) :
                        <Text {...element} disabled={disabled} key={index} />
                )}
            </OperationalContent>
        </Stack>
    );
};
